import React from 'react';
import { Container, Typography, Box, Button, Link } from '@mui/material';

const Contact = () => {
  const yourEmail = 'www.beaconbin2004@gmail.com';
  const subject = 'Message from your portfolio contact form';
  const body = 'Hello, I would like to get in touch with you.';

  return (
    <Container sx={{ mt: 4, mb: 6 }}>
      {/* Heading */}
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          textAlign: 'center', // Center the title
          fontWeight: 'bold',  // Make the title bold
          color: '#333', // Text color
        }}
      >
        Contact Me
      </Typography>

      {/* Displaying your details */}
      <Box
        sx={{
          backgroundColor: '#f4f4f4', // Light background color for the details box
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', // Shadow for the box
          textAlign:'left', // Center the text inside the details box
          maxWidth: 600, // Limit the width of the details box
          margin: '0 auto', // Center the box horizontally
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
          Name: Nelviesh Willson
        </Typography>
        <Typography variant="h6" sx={{ mb: 1 }}>
          College: Government College of Engineering, Tirunelveli
        </Typography>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Mobile: 9043527400
        </Typography>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Email: <Link href={`mailto:${yourEmail}`} color="primary">{yourEmail}</Link>
        </Typography>
      </Box>

      {/* Contact Message Button */}
      <Box sx={{ textAlign: 'center' }}>
        <Button
          variant="contained"
          color="white"
          
          sx={{ mt: 2,backgroundColor:'#515669',color:'white' }}
          component="a"
          href={`mailto:${yourEmail}?subject=${subject}&body=${body}`}
        >
          Send Message
        </Button>
      </Box>
    </Container>
  );
};

export default Contact;
